import { PageMeta } from '@/components/ui/PageMeta';
import { LegalDocumentView } from '@/components/legal/LegalDocumentView';

export function TermsOfUsePage() {
  return (
    <>
      <PageMeta
        title="Termos de Uso | Operax"
        description="Condições de uso da plataforma Operax."
      />
      <LegalDocumentView code="terms_of_service" fallbackTitle="Termos de Uso" />
    </>
  );
}
